import MainServices from "./Main.services";
import getState, { dynamicSort } from "../utils/MainHelper";
import { getAllKeywordsInFolder, getCountryCode } from "../utils/oneintelligence/OneIntelligenceHelper";

class AudienceServices {
    getAdvertiser() {
        const {
            advertiserList, lobList
        } = getState("audience");
        if (advertiserList.length) return Promise.resolve(advertiserList)
        return MainServices.getPermission("advertiser", {}, "permAdvertiser")
            .then(({
                data,
                isSuccess,
                message: msg
            }) => {
                if (isSuccess) {
                    return Object.values(data).map((item) => {
                        return {
                            name: item.name,
                            id: item.id + "~" + item.code,
                            code: item.code,
                            id_gamma_dsp: item.partnerId
                        }
                    }).sort(dynamicSort("name"));
                } else {
                    return [];
                }
            })
            .catch((err) => []);
    }

    getAdvertiserLOB(idAccount) {
        const {
            advertiserList, lobList
        } = getState("audience");
        if (lobList.length) return Promise.resolve(lobList)
        return MainServices.getPermission("lobusergroup", { idAccount: idAccount.split("~")[0] }, "permLob").then(({
            data,
            isSuccess,
            message: msg
        }) => {
            if (isSuccess) {
                return Object.values(data).map((item) => {
                    return {
                        name: item.name,
                        id: item.id + "~" + item.id_op,
                        idAccount: item.idAccount,
                        id_op: item.id_op,
                        client_id: item.client_id
                    }
                }).sort(dynamicSort("name"));
            } else {
                return [];
            }
        }).catch((e) => []);
    }

    getAudienceList(adv, lob, itemsInPage = 500, pageNumber = 1) {
        const {
            setup: {
                marketPackage
            }
        } = getState("buildTargets");

        return MainServices.get(
            {
                path: "audiencemanager/audiencepackages", params: {
                    lob_id: lob.value.split("~")[1],
                    country_code: getCountryCode("savant"),
                    market_package: marketPackage.parent.code,
                    module: marketPackage.code,
                    itemsInPage,
                    pageNumber
                }
            })
    }

    uploadAudienceMaster(id) {
        const {
            configuration
        } = getState("marketExplorer");
        return MainServices.uploadFile(`masters/${id}.json`, JSON.stringify(configuration), {}, "audience");
    }

    uploadAudienceMPCountrySetup(id) {
        const {
            setup
        } = getState("buildTargets");
        return MainServices.uploadFile(`mpcountrysetup/${id}.json`, JSON.stringify(setup), {}, "audience");
    }

    uploadAudienceKeywords(id, listItem) {
        const promiseList = [];
        const uploadKeyword = (item, arr) => this.uploadFile(`microsegments/${id}/${item}.json`, JSON.stringify(arr), {}, "audience");
        const tempObj = {};
        const recursiveGetMicrosegmnt = (children, parent, obj) => {
            const [firstChild] = children;
            const fcChildList = firstChild.children || firstChild.tempChildren;
            if (!fcChildList) {
                obj[parent.item || parent.name] = getAllKeywordsInFolder(children, []);
            } else {
                children.forEach((child) => {
                    const childList = child.children || child.tempChildren;
                    if (childList?.length) {
                        recursiveGetMicrosegmnt(childList, child, obj);
                    }
                });
            }

            return obj;
        };
        listItem.forEach((item) => {
            const childList = item.children || item.tempChildren;
            if (childList?.length) {
                tempObj[item.item || item.name] = recursiveGetMicrosegmnt(childList, item, {});
            }
        });
        Object.keys(tempObj).forEach((key) => {
            promiseList.push(uploadKeyword(key, tempObj[key]));
        });
        return Promise.all(promiseList);
    }

    getAudienceJSON(path) {
        return MainServices.getFile(
            path,
            "audience"
        );
    }

    createNewAudience(requestBody, behaviors, monitorCallBack = () => { }) {
        const url = MainServices.url + "audiencemanager/audiencepackages"
        monitorCallBack(requestBody, url)
        return MainServices.post(
            url,
            requestBody,
            { noCredentials: false }
        ).then(async (resp) => {
            if (resp.audiencepackage) {
                const { id } = resp.audiencepackage;
                await this.uploadAudienceMPCountrySetup(id);
                await this.uploadAudienceMaster(id);
                // await this.uploadAudienceKeywords(id, behaviors);
            }
            return resp;
        });
    }

    updateAudience({ id, savant_url }, list, behaviors, monitorCallBack = () => { }) {
        const url = MainServices.url + "audiencemanager/audiencepackages"
        const requestBody = {
            id,
            mask: "savant_url,addbehaviors",
            data: {
                savant_url,
                addbehaviors: list
            }
        }
        monitorCallBack(requestBody, url)
        return MainServices.put(
            url,
            requestBody,
            { noCredentials: false }
        ).then(async (resp) => {
            if (resp.audiencepackage) {
                await this.uploadAudienceMPCountrySetup(id);
                await this.uploadAudienceMaster(id);
                // await this.uploadAudienceKeywords(id, behaviors);
            }
            return resp;
        });
    }
}

export default new AudienceServices();
